import React from "react"

import classNames from "classnames"

import { IconSize } from "shared/types/Icon"
import {
  BoxSelectControl,
  BoxSelectProps
} from "shared/ui/input/select/box/BoxSelectControl"
import { Skeleton } from "shared/ui/skeleton/Skeleton"

export interface SwitchProps<T extends string>
  extends Omit<BoxSelectProps<T, false>, "isMulti" | "inputRef"> {}

function SwitchComponent<T extends string>({
  className,
  isLoading,
  iconSize = IconSize.SMALL,
  ...props
}: SwitchProps<T>) {
  if (isLoading) {
    return <Skeleton className={classNames("switch", "loading", className)} />
  }

  return (
    <BoxSelectControl
      {...props}
      iconSize={iconSize}
      isMulti={false}
      className={classNames("switch", className)}
    />
  )
}

export const Switch = React.memo(
  React.memo(SwitchComponent)
) as typeof SwitchComponent
